export default __webpack_public_path__ + "static/media/h.2757e055.jpg";